import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import tutorialEn from './locales/tutorial-en.json';
import tutorialFr from './locales/tutorial-fr.json';

function mergeTranslation(base: Record<string, unknown>, tutorial: Record<string, unknown>) {
  return { ...base, tutorial };
}

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: { translation: mergeTranslation(en, tutorialEn) },
      fr: { translation: mergeTranslation(fr, tutorialFr) },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    
    // Language detection options
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language in localStorage
      caches: ['localStorage'],
      // localStorage key
      lookupLocalStorage: 'ugridplan-language'
    },

    interpolation: {
      // React already escapes values
      escapeValue: false
    },

    // Debug mode in development
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;

